
import withValues from '../hocs/withValues'
import AutoInput from '../containers/AutoInput'
import React, { Component } from 'react'
import { Form, Tabs, message, Button } from 'antd';
import { getValue } from '../utils/models';
import { request } from "../utils/http";
import custom from "../config/custom";

const TabPane = Tabs.TabPane

class InstructionLetterEdit extends Component {

    constructor(props) {
        super(props)

        this.state = {
            customer: null,
            customerQuery: null,
            servicetype: null,
            servicetypeQuery: null,
            numberPhone:null
        };
        this.createQuote = this.createQuote.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.values.phone_number !== prevProps.values.phone_number) {
          this.setState({
            numberPhone: getValue(this.props.values, "phone_number")
          });
        }
      }

    createQuote(e) {
        e.stopPropagation();
        request(`${custom.baseUrl}/create-quote/${this.props.id}`, {
          method: "POST",
          data: { id: this.props.id}
        })
          .then(() => {
            message.success("Quote has been created");
          })
          .catch(error => {
            message.warning("Error in quote creation", error);
          });
      }

    render() {
        return (
            <div style={{ marginTop: -25 }}>
                <Tabs defaultActiveKey="letter">
                    <TabPane tab="Carta de Instrucciones" key="letter">
                        <Form>
                            <AutoInput
                                form={this.props.form}
                                model={"instructionletter"}
                                attribute={"customerId"}
                                id={this.props.id}
                                disabled={this.props.disabled}
                                ajax
                                onSearch={value => {
                                    this.setState({ customerQuery: value, active: true });
                                }}
                                onChange={value => {
                                    const { id } = JSON.parse(value);
                                    this.setState({ customer: id });
                                }}
                                value={getValue(this.props.values, 'customerId')}
                            />
                            <AutoInput
                                form={this.props.form}
                                attribute={'address'}
                                id={this.props.id}
                                model={'instructionletter'}
                                disabled={this.props.disabled}
                                value={getValue(this.props.values, 'address')}
                            />
                            <AutoInput
                                form={this.props.form}
                                attribute={'rfc'}
                                id={this.props.id}
                                model={'instructionletter'}
                                disabled={this.props.disabled}
                                value={getValue(this.props.values, 'rfc')}
                            />
                            <AutoInput
                                form={this.props.form}
                                model={'instructionletter'}
                                disabled={this.props.disabled}
                                value={getValue(this.props.values, 'email')}
                                attribute={'email'}
                                id={this.props.id}
                            />
                            <AutoInput
                                form={this.props.form}
                                model={'instructionletter'}
                                attribute={'phone_number'}
                                value={this.state.numberPhone}
                            />
                            <div className='aproveQuote'>
                                <Button type='primary' onClick={this.createQuote}>Crear Cotizacion</Button>
                            </div>
                        </Form>
                    </TabPane>
                    <TabPane tab="Tipo de Servicio" key="type_service">
                        <Form>
                            <AutoInput
                                form={this.props.form}
                                model={'instructionletter'}
                                disabled={this.props.disabled}
                                id={this.props.id}
                                attribute={'type_service'}
                                value={getValue(this.props.values, 'id')}
                                delayTime={100}
                            />
                            <AutoInput
                                form={this.props.form}
                                model={'instructionletter'}
                                disabled={this.props.disabled}
                                attribute={'reference'}
                                id={this.props.id}
                                value={getValue(this.props.values, 'reference')}
                            />
                            <AutoInput
                                form={this.props.form}
                                model={'instructionletter'}
                                disabled={this.props.disabled}
                                attribute={'incoterm'}
                                id={this.props.id}
                                value={getValue(this.props.values, 'incoterm')}
                            />
                            <AutoInput
                                form={this.props.form}
                                model={'instructionletter'}
                                disabled={this.props.disabled}
                                attribute={'pickup_address'}
                                id={this.props.id}
                                value={getValue(this.props.values, 'pickup_address')}
                            />
                            <AutoInput
                                form={this.props.form}
                                model={'instructionletter'}
                                disabled={this.props.disabled}
                                attribute={'pol'}
                                id={this.props.id}
                                value={getValue(this.props.values, 'pol')}
                            />
                            <AutoInput
                                form={this.props.form}
                                model={'instructionletter'}
                                disabled={this.props.disabled}
                                attribute={'pod'}
                                id={this.props.id}
                                value={getValue(this.props.values, 'pod')}
                            />
                            <AutoInput
                                form={this.props.form}
                                model={'instructionletter'}
                                disabled={this.props.disabled}
                                attribute={'delivery_address'}
                                id={this.props.id}
                                value={getValue(this.props.values, 'delivery_address')}
                            />
                        </Form>
                    </TabPane>
                    <TabPane tab="Mercancia" key="merchandise">
                        <Form>
                            <AutoInput
                                form={this.props.form}
                                model={'instructionletter'}
                                disabled={this.props.disabled}
                                attribute={'description'}
                                id={this.props.id}
                                value={getValue(this.props.values, 'description')}
                            />
                            <AutoInput
                                form={this.props.form}
                                model={'instructionletter'}
                                disabled={this.props.disabled}
                                attribute={'tariff'}
                                id={this.props.id}
                                value={getValue(this.props.values, 'tariff')}
                            />
                            <AutoInput
                                form={this.props.form}
                                model={'instructionletter'}
                                disabled={this.props.disabled}
                                attribute={'type_packaging'}
                                id={this.props.id}
                                value={getValue(this.props.values, 'type_packaging')}
                            />
                            <AutoInput
                                form={this.props.form}
                                model={'instructionletter'}
                                disabled={this.props.disabled}
                                attribute={'volume'}
                                id={this.props.id}
                                value={getValue(this.props.values, 'volume')}
                            />
                            <AutoInput
                                form={this.props.form}
                                model={'instructionletter'}
                                disabled={this.props.disabled}
                                attribute={'weight'}
                                id={this.props.id}
                                value={getValue(this.props.values, 'weight')}
                            />
                            <AutoInput
                                form={this.props.form}
                                model={'instructionletter'}
                                disabled={this.props.disabled}
                                attribute={'cbm'}
                                id={this.props.id}
                                value={getValue(this.props.values, 'cbm')}
                            />
                            <AutoInput
                                form={this.props.form}
                                model={'instructionletter'}
                                disabled={this.props.disabled}
                                attribute={'lenght'}
                                id={this.props.id}
                                value={getValue(this.props.values, 'lenght')}
                            />
                            <AutoInput
                                form={this.props.form}
                                model={'instructionletter'}
                                disabled={this.props.disabled}
                                attribute={'width'}
                                id={this.props.id}
                                value={getValue(this.props.values, 'width')}
                            />
                            <AutoInput
                                form={this.props.form}
                                model={'instructionletter'}
                                disabled={this.props.disabled}
                                attribute={'height'}
                                id={this.props.id}
                                value={getValue(this.props.values, 'height')}
                            />
                            <AutoInput
                                form={this.props.form}
                                model={'instructionletter'}
                                disabled={this.props.disabled}
                                attribute={'quantity'}
                                id={this.props.id}
                                value={getValue(this.props.values, 'quantity')}
                            />
                        </Form>
                    </TabPane>
                    <TabPane tab="Instrucciones Especiales" key="special_info">
                        <Form>
                            <AutoInput
                                form={this.props.form}
                                model={'instructionletter'}
                                disabled={this.props.disabled}
                                attribute={'special_description'}
                                id={this.props.id}
                                value={getValue(this.props.values, 'special_description')} />
                        </Form>
                    </TabPane>
                </Tabs>
            </div>
        )
    }
}

export default withValues(InstructionLetterEdit)



// WEBPACK FOOTER //
// ./src/forms/InstructionLetterEdit.js